import {Container, Image, rem, SimpleGrid, Text, Title} from "@mantine/core";
import {PropsWithChildren} from "react";
import {createContentStyles} from "../../theme/useContentStyles";

export type ResultProps = {
  title: string
  message?: string
  imgSrc?: string
}

const useStyles = createContentStyles((theme) => ({
  root: {
    paddingTop: rem(80),
    paddingBottom: rem(80)
  },

  title: {
    fontWeight: 900,
    fontSize: rem(34),
    marginBottom: theme.spacing.md,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(32)
    }
  },

  control: {
    [theme.fn.smallerThan("sm")]: {
      width: "100%"
    }
  },

  mobileImage: {
    [theme.fn.largerThan("sm")]: {
      display: "none"
    }
  },

  desktopImage: {
    [theme.fn.smallerThan("sm")]: {
      display: "none"
    }
  }
}));

export function Result(props: PropsWithChildren<ResultProps>) {
  const {title, message, imgSrc, children} = props;

  const {classes} = useStyles();

  return (
    <Container className={classes.root}>
      <SimpleGrid spacing={80} cols={2} breakpoints={[{maxWidth: "sm", cols: 1, spacing: 40}]}>
        {imgSrc && <Image src={imgSrc} className={classes.mobileImage}/>}
        <div>
          <Title className={classes.title}>{title}</Title>
          {message &&
            <Text color="dimmed" size="lg">
              {message}
            </Text>
          }
          <div className={classes.control}>
            {children}
          </div>
        </div>
        {imgSrc && <Image src={imgSrc} className={classes.desktopImage}/>}
      </SimpleGrid>
    </Container>
  );
}
